import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import ContentContainerRaw from 'remote-com-shared/components/ContentContainer';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { CallToAction } from './CallToAction';
import { GatedContent } from './GatedContent';
import { ImageBanner } from './ImageBanner';

const components = {
  gated_content: GatedContent,
  call_to_action: CallToAction,
  image_only_and_link: ImageBanner,
};

const ContentContainer = styled(ContentContainerRaw)`
  &:last-child {
    ${fluidProp('padding-bottom', '40px', '130px')}
  }
`;

// Because this was initially created for the blog, the main slices are formatted to contentful
function transformBannersToContentful(body) {
  return body.map((prismicSlice) => {
    const { sliceType: sourceSliceType, slice_type: sliceType = sourceSliceType } = prismicSlice;

    if (sliceType === 'gated_content') {
      return { ...prismicSlice };
    }
    return prismicSlice;
  });
}

export function MarketingBannerSlice({ slice, context }) {
  const { primary } = slice;
  const {
    banner: { body },
  } = primary;

  if (!body) {
    return null;
  }

  return (
    <>
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
      </Head>
      <ContentContainer>
        <SliceZone
          slices={transformBannersToContentful(body)}
          components={components}
          context={{ banner: primary.banner, bannerInstance: primary.banner, primary, ...context }}
        />
      </ContentContainer>
    </>
  );
}
